import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DashboardInternshipTab from "./DashboardInternshipTab";
import DashboardInternshipActiveTab from "./DashboardInternshipActiveTab";
import { getAllStaff, getInternRequestWithFullData, getSchoolYearB} from "../../api/crud";
import { optionsBranch } from "../../data/branch-data";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid, Paper } from "@mui/material";
import Select from "react-select";
import { matchOptions } from "../../utils/function";
import { internType } from "../../data/interntype-data";
import { Tooltip, IconButton } from "@mui/material";
import ReactExport from "react-data-export";
import { updateIsLoading } from "../../redux/action/dataAction";

import { currentYear } from "../../data/config";
import {useMediaQuery} from '@mui/material';
import { is } from "date-fns/locale";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pt: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function DashboardEvalutionPage() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profileReducer.profile);
  const isMobile = useMediaQuery('(max-width:767px)');

  const [value, setValue] = useState(1);
  const [cardActive, setcardActive] = useState("1");
  const [textActive, setTextActive] = useState("ทั้งหมด");
  const [items, setItems] = useState([]);
  const [itemsByBranch, setItemByBranch] = useState([]);
  const [itemsBySupervisorBranch, setItemsBySupervisorBranch] = useState([]);
  const [itemsByBranchFilter, setItemByBranchFilter] = useState([]);
  const [itemsBySupervisorBranchFilter, setItemsBySupervisorBranchFilter] =
    useState([]);
  const [allStaff, setAllStaff] = useState([]);
  const [schoolYear, setSchoolYear] = useState([]);
  //console.log("itemsByBranchFilter", itemsByBranchFilter);

  const [optionsNewBranch, setOptionsNewBranch] = useState([
    {
      label: "ทั้งหมด",
      value: 0,
    },
    ...optionsBranch,
  ]);
  const [branchSelected, setBranchSelected] = useState(null);

  const focusItems = value === 0 ? itemsByBranch : itemsBySupervisorBranch;

  // const [focusItems, setFocusItems] = useState([]);

  const onHandleBranchSelect = (data) => {
    setBranchSelected(data);
  };

  const getOptionOwn = (options, profile) => {
    if (profile && profile.set_b_id && profile.b_id !== "0") {
      const setBId = JSON.parse(profile.set_b_id);

      const newOptions = [...options].filter(
        (opt) => setBId.indexOf(opt.value) !== -1
      );

      if (newOptions.length) {
        return newOptions;
      }
    } else if (profile && profile.b_id && profile.b_id !== "0") {
      const newOptions = [...options].filter(
        (opt) => profile.b_id == opt.value
      );

      if (newOptions.length) {
        return newOptions;
      }
    } else if (profile && profile.b_id && profile.b_id == "0") {
      return options;
    }

    return [];
  };

  useEffect(() => {
    const options = getOptionOwn([...optionsNewBranch], profile);

    setOptionsNewBranch(options);

    if (options.length) {
      const defaultOptions = options[0];
      setBranchSelected(defaultOptions);
    }
  }, [profile]);

  const getData = async () => {
    dispatch(updateIsLoading(true));

    try {
      const schoolYear = await getSchoolYearB();
      setSchoolYear(schoolYear);
      const resIntern = await getInternRequestWithFullData();
      const resStaff = await getAllStaff();
        
      const mapStaff = await resStaff.map((staff) => {
        const internOwn =
          resIntern.filter((int) => int.supervisor === staff.id) ?? [];

        return {
          ...staff,
          internOwn,
        };
      });

      //console.log({ resIntern });

      setItems(resIntern);
      //console.log({ resIntern });
      setAllStaff(mapStaff);
    } catch (err) {
      console.warn(err);
    } finally {
      dispatch(updateIsLoading(false));
    }
  };

  const onHandleItemsByBranch = (items, branchSelected) => {
    const studentByBranch = items.filter((student) => {
      if (branchSelected.value == 0) {
        return student;
      } else {
        return student.internStudent?.b_id == branchSelected.value;
      }
    });

    const rows = studentByBranch.filter(
      (item) => +item.st_id && item.status != "0"
    );

    const sortData = rows.sort((a, b) => (a.st_id > b.st_id ? 1 : -1));

    return sortData;
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    getData();
  }, []);

  
  useEffect(() => {
    if (items.length && branchSelected && profile) {
      const itemsB = onHandleItemsByBranch(items, branchSelected);

    //  console.log("itemsB", itemsB);
      setItemByBranch(itemsB);
      setItemByBranchFilter(itemsB);

      const itemsBySupervisor = itemsB.filter(
        (item) => item.supervisor === profile.id
      );

      setItemsBySupervisorBranch(itemsBySupervisor);
      setItemsBySupervisorBranchFilter(itemsBySupervisor);
      setValue(0);
      // if (itemsBySupervisor.length) {
      //   setValue(1);
      // } else {
      //   setValue(0);  
      // }
      
    }
  }, [branchSelected, items, profile]);

  return (
    <Box sx={{ width: "100%" }}>
      <Container maxWidth="xl">
        {/* Header Section with Enhanced Styling */}
        <Paper 
          elevation={2} 
          sx={{ 
            p: 3, 
            mb: 3, 
            background: 'linear-gradient(135deg, #6b7a8a 0%, #5a6a7a 100%)',
            borderRadius: 2,
            border: '1px solid #4a5a6a'
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={8}>
              <Box display="flex" alignItems="center" gap={2}>
               
                <Box>
                  <Typography 
                    variant={isMobile ? "h6" : "h4"} 
                    sx={{
                      fontWeight: 'bold',
                      color: 'white',
                      mb: 0.5,
                      fontFamily: '"TH Sarabun New", "Sarabun", sans-serif'
                    }}
                  >
                    การประเมินผลการฝึกงาน 2 เดือน
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontWeight: 500
                    }}
                  >
                    ระบบติดตามและประเมินผลการฝึกงานนิสิต
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box display="flex" justifyContent={{ xs: 'flex-start', md: 'flex-end' }} width="100%">
                <Box sx={{ minWidth: 200, maxWidth: 300 }}>
                  {profile?.b_id === "0" && (
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        mb: 1, 
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontWeight: 500
                      }}
                    >
                      เลือกสาขาวิชา:
                    </Typography>
                  )}
                  <Select
                    options={optionsNewBranch}
                    value={branchSelected}
                    onChange={onHandleBranchSelect}
                    placeholder="เลือกสาขา..."
                    isDisabled={profile?.b_id !== "0"}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: '2px solid #e3f2fd',
                        borderRadius: '8px',
                        boxShadow: state.isFocused ? '0 0 0 2px rgba(33, 150, 243, 0.2)' : 'none',
                        backgroundColor: profile?.b_id !== "0" ? '#f5f5f5' : 'white',
                        '&:hover': {
                          borderColor: profile?.b_id !== "0" ? '#e3f2fd' : '#2196f3'
                        }
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#e3f2fd' : 'white',
                        color: state.isFocused ? '#1976d2' : '#333',
                        fontWeight: state.isSelected ? 600 : 400
                      })
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        <Grid container spacing={2}>

         

          {/* <Grid item xs={12}>
            <Paper>
              <Tabs value={value} onChange={handleChange}>
                <Tab
                  label={`ทั้งหมด (${itemsByBranchFilter.length ?? 0})`}
                  {...a11yProps(0)}
                />
                <Tab
                  label={`นิสิตที่เลือกไปนิเทศ (${
                    itemsBySupervisorBranchFilter.length ?? 0
                  })`}
                  {...a11yProps(1)}
                />
              </Tabs>
            </Paper>
          </Grid> */}
        </Grid>
      </Container>

      <TabPanel value={value} index={0}>
        <DashboardInternshipTab
          textActive={textActive}
          items={itemsByBranchFilter}
          allStaff={allStaff}
          onRefresh={getData} // ส่งฟังก์ชัน getData สำหรับ refresh ข้อมูล
        />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <DashboardInternshipActiveTab
          items={itemsBySupervisorBranchFilter}
          allStaff={allStaff}
          profile={profile}
          textActive={textActive}
        />
      </TabPanel>
    </Box>
  );
}
